/*
 * @Author: cgh
 * @Date: 2022-08-02 15:57:47
 * @LastEditors: DQL
 * @LastEditTime: 2022-09-20 10:16:50
 * @Description: 人员签到信息管理
 */

import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;

export const qdxxService = {
  // 查询
  query: (params) => { return axios.get(`${iffApi}/common/getQdlb`, { params: params }); },

  // 导出
  export: (params) => { return axios.get(`${iffApi}/common/qdListExport`, { responseType: 'blob', params }); }
};
